import ToastEventBus from 'primevue/toasteventbus';

const toast = {
  add: (message) => ToastEventBus.emit('add', message),
  removeGroup: (group) => ToastEventBus.emit('remove-group', group),
  removeAllGroups: () => ToastEventBus.emit('remove-all-groups'),
};

export const showNotification = (
  severity = 'info',
  summary = null,
  detail = null,
  life = null,
  closable = true,
  group = null,
  styleClass = null,
  contentStyleClass = null
) => {
  toast.add({
    severity: severity,
    summary: summary,
    detail:  detail,
    life: life,
    closable: closable,
    group: group,
    styleClass: styleClass,
    contentStyleClass: contentStyleClass
  });
}
